import { useContext } from "react";
import { Button, Paper, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import FormContainer from "./rh_form_elements/rh-form-container.js";
import SelectAllTransferList from "./rh_form_elements/transfer-list-element.js";
import { Stack } from "@mui/material";
import Skeleton from '@mui/material/Skeleton';
import {useGetOrgUsers} from "../../api/orgusers.js";
import {useGetCaseUsers, useAssignUsersToCase, useUnassignUsersFromCase} from "../../api/caseusers.js";
import UserProfileContext from "../../context/userprofilecontext.js";
import SnackbarContext from "../../context/snackbar-context.js";
import { handleDisplayResponseResults } from "../../api/api_util.js";




export default function CaseAssignmentForm(props) {



  const userProfileContext=useContext(UserProfileContext);
  const snackbarContext=useContext(SnackbarContext);

  const assignUsersToCase = useAssignUsersToCase()
  const unassignUserFromCase = useUnassignUsersFromCase()

  const userProfile = userProfileContext.userProfile
  const orgID=userProfile?.currentOrg?.orgID
  const caseID=userProfile?.currentCase?.caseID

  const usersForOrgResult = useGetOrgUsers(orgID)
  const usersForOrgCaseResult = useGetCaseUsers(orgID,caseID)

  const defaultValues = props.data?props.data:{};


  //const [values, setValues] = useState(defaultValues)
  const values = defaultValues


  const formContext = useForm({
    defaultValues: defaultValues, values
  });

  const { register, handleSubmit, reset, control, setValue, formState: { errors } } = formContext;






  const onSubmit = (data) => {
    console.log(data);
    handleSave(data.userList)
  };


  if(!usersForOrgResult.data || !usersForOrgCaseResult.data || userProfileContext.isLoading) {
    return(
      <Paper
        style={{
          display: "grid",
          gridRowGap: "20px",
          padding: "20px",
          //margin: "10px 300px",
          maxWidth: "650px",
        }}
      >
        <Skeleton variant="rectangular" sx={{minHeight: 300}} />


      </Paper>
    )
  }

  const currentUserID=userProfileContext.userProfile.currentUser.userID
  // list all users except the current user
  const choices = usersForOrgResult.data.filter((user)=>user.userID!==currentUserID)
  const usersForOrgCaseArray = Object.values(usersForOrgCaseResult.data || {});
  const value = usersForOrgCaseArray.map((user)=>user.userID).filter(userID=>userID!==currentUserID)

  const getItemKey=(item)=>item.userID
  const getItemDisplay=(item)=>item.firstName+ " " + item.lastName


  const handleSave = async (userIDs) => {
    try{



      const itemsToDelete = value.filter((item)=>!userIDs.includes(item))
      const itemsToAdd = userIDs.filter((item)=>!value.includes(item))
      console.log(`itemsToDelete=${JSON.stringify(itemsToDelete)}`)
      console.log(`itemsToAdd=${JSON.stringify(itemsToAdd)}`)

      try {
        const addResponse = await assignUsersToCase(orgID,caseID,itemsToAdd);
        console.log('Add Response:', addResponse);
        const formatAddSuccess = (result) => `User ${result.item.userID} was assigned`
        const formatAddError = (result) => `User ${result.userID} could not be assigned`

        handleDisplayResponseResults(addResponse, snackbarContext, formatAddSuccess, formatAddError)

        const deleteResponse = await unassignUserFromCase(orgID,caseID,itemsToDelete);
        console.log('Delete Response:', deleteResponse);

        const formatDeleteSuccess = (result) => `User ${result.item.userID} was unassigned`
        const formatDeleteError = (result) => `User ${result.userID} could not be unassigned`

        handleDisplayResponseResults(deleteResponse, snackbarContext, formatDeleteSuccess, formatDeleteError)


      } catch (error) {
        console.error('Error:', error);
        snackbarContext.openSnackbarError(JSON.stringify(error))
      }

    } catch (error) {
      console.error('Error updating asssigments:', error);
    }
  }

  if (choices.length === 0 && value.length === 0) {
    return (
      <Paper
        style={{
          display: "grid",
          gridRowGap: "20px",
          padding: "20px",
          //margin: "10px 300px",
          maxWidth: "650px",
        }}
      >
        <Typography>No users available for assignment, please add users to the Organization using "Manage Team" first</Typography>
      </Paper>
    )
  }

  return (



      <Paper
        style={{
          display: "grid",
          gridRowGap: "20px",
          padding: "20px",
          //margin: "10px 300px",
          maxWidth: "650px",
        }}
      >

        <FormContainer formContext={formContext} handleSubmit={handleSubmit} >
          <Stack spacing={2}>
            <SelectAllTransferList name="userList" label="Users for Case" choicesTitle="Available Users" chosenTitle="Assigned Users" choices={choices} value={value} getItemKey={getItemKey} getItemDisplay={getItemDisplay} setValue={setValue}/>
          </Stack>


          <Button
            style={{
              //padding: "20px",
              margin: "10px 0px",
              maxWidth: "75px",
            }}
            onClick={handleSubmit(onSubmit)} variant={"contained"}>
            Save
          </Button>



        </FormContainer>

      </Paper>




  );
};